import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ServiceChangesModel} from '../../../models/ServiceChangesModel';
import {LocalCustomerModel} from '../../../models/LocalCustomerModel';
import {RegionModel} from '../../../models/RegionModel';
import {ResourcesUnitModel} from '../../../models/ResourcesUnitModel';
import {MatDialog, MatTableDataSource} from '@angular/material';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {ServiceChangesService} from '../service/service-changes.service';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {NumAnnoMeseService} from '../../general-services/service-num-anno-mese/num-anno-mese.service';
import * as toastr from 'toastr';
import {DialogSubmitServiceChangesComponent} from '../dialog-submit-service-changes/dialog-submit-service-changes.component';
import {ContractTypeModel} from '../../../models/ContractTypeModel';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import {ProviderModel} from '../../../models/ProviderModel';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';

@Component({
  selector: 'app-new-service-changes-massive',
  templateUrl: './new-service-changes-massive.component.html',
  styleUrls: ['./new-service-changes-massive.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: {showError: true}
  }]
})
export class NewServiceChangesMassiveComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  serviceChanges: ServiceChangesModel;
  localCustomerSelect: LocalCustomerModel;
  regionSelect: RegionModel;
  resourceUnitSelect: ResourcesUnitModel;
  contractTypeSelect: ContractTypeModel;
  providerSelect: ProviderModel;
  saveServiceChanges: Subscription;
  getPageSubscribe: Subscription;
  allMonth: any;
  listData: MatTableDataSource<any>;

  enableLC: boolean;
  enableRU: boolean;

  showLC: boolean;
  showRegion: boolean;
  showResourceUnit: boolean;
  showActions: boolean;
  showContractType: boolean;
  showProvider: boolean;

  annoMeseFormGroup: FormGroup;
  tablesFormGroup: FormGroup;
  finalStepFormGroup: FormGroup;
  isLinear: boolean;

  numAnnoMeseFrom: number;
  numAnnoMeseTo: number;


  constructor(private route: ActivatedRoute, private router: Router,
              private serviceChangesService: ServiceChangesService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService,
              private annoMeseService: NumAnnoMeseService,
              private dialog: MatDialog) {
    super();

    this.showActions = false;
    this.showLC  = false;
    this.showRegion  = false;
    this.isLinear = true;
    this.serviceChanges = new ServiceChangesModel();
    this.contractTypeSelect = new ContractTypeModel();
    this.localCustomerSelect = new LocalCustomerModel();
    this.regionSelect = new RegionModel();
    this.resourceUnitSelect = new ResourcesUnitModel();
    this.providerSelect = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.serviceChanges.provider = this.providerSelect;
  }

  ngOnInit() {
    this.getAllMonth();

    this.annoMeseFormGroup = this.formBuilder.group({
      annoMeseFrom: [{value: '', disabled: false}, Validators.required],
      annoMeseTo: [{value: '', disabled: false}, Validators.required],
    });
    this.tablesFormGroup = this.formBuilder.group({
      region: [{value: '', disabled: false}, Validators.required],
      localCustomerCod: [{value: '', disabled: false}, Validators.required],
      resourceUnit: [{value: '', disabled: false}, Validators.required],
      contractType: [{value: '', disabled: false}, Validators.required],
      provider: [{value: this.providerSelect.cod, disabled: false}, Validators.required]
    });

    this.finalStepFormGroup = this.formBuilder.group({
      shareName: [{value: '', disabled: false}],
      delta: [{value: '', disabled: false}, Validators.required]
    });
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.SERVICE_CHANGES], {queryParams: {selectedIndex: 0}});
  }

  save() {
    if (this.annoMeseFormGroup.valid && this.tablesFormGroup.valid && this.finalStepFormGroup.valid) {
      this.serviceChanges.shareName = this.finalStepFormGroup.value.shareName;
      this.serviceChanges.delta = this.finalStepFormGroup.value.delta;
      this.serviceChanges.numAnnoMese = null;
      this.serviceChanges.numAnnoMeseFrom = this.annoMeseFormGroup.value.annoMeseFrom;
      this.serviceChanges.numAnnoMeseTo = this.annoMeseFormGroup.value.annoMeseTo;

      event.preventDefault();
      this.loaderService.display(true);
      this.saveServiceChanges = this.serviceChangesService.saveMassive(this.serviceChangesService.baseUrl, this.serviceChanges)
        .subscribe(
          (result: any) => {
            if (result === -1) {
              toastr.options.timeout = 5000;
              toastr.warning('Duplicate item, cannot be created', 'Warning');
              this.loaderService.display(false);
            } else {
              this.loaderService.display(false);
              this.apriDialog(result);
              this.router.navigate([this.LINKS.SERVICE_CHANGES]);
            }
          },
          error => {
            toastr.error('Service Change was not created', 'Error');
            this.loaderService.display(false);
          });
    }
  }


  getAllMonth() {
    this.getPageSubscribe = this.annoMeseService.getAllMonth()
      .subscribe(
        (result: any[]) => {
          this.allMonth = result;

          const lastNumAnnoMese = result[result.length - 1] ? result[result.length - 1] : null;
          this.serviceChanges.numAnnoMeseTo = lastNumAnnoMese
          this.annoMeseFormGroup.value.annoMeseTo = lastNumAnnoMese;

          this.annoMeseFormGroup.patchValue({
            annoMeseTo: lastNumAnnoMese
          });

        });
  }

  ngOnDestroy(): void {
    if (this.saveServiceChanges) {
      this.saveServiceChanges.unsubscribe();
    }
  }

  getElementSelectedRegion($event) {
    this.enableLC = true;
    this.serviceChanges.region = $event.row;
    this.regionSelect = $event.row;
    this.tablesFormGroup.patchValue({
      region: this.regionSelect.cod
    });
  }

  getElementSelectedLC($event) {
    this.enableRU = true;
    this.serviceChanges.localCustomer = $event.row;
    this.localCustomerSelect = $event.row;
    this.tablesFormGroup.patchValue({
      localCustomerCod: this.localCustomerSelect.cod
    });
  }

  getElementSelectedResourceUnit($event) {
    this.serviceChanges.resourceUnit = $event.row;
    this.resourceUnitSelect = $event.row;
    this.tablesFormGroup.patchValue({
      resourceUnit : this.resourceUnitSelect.cod
    });
  }

  getElementSelectedContractType($event) {
    this.serviceChanges.contractType = $event.row;
    this.contractTypeSelect = $event.row;
    this.tablesFormGroup.patchValue({
      contractType : this.contractTypeSelect.cod
    });
  }

  toggleLC() {
    this.showLC = !this.showLC;
  }

  toggleRegion() {
    this.showRegion = !this.showRegion;
  }

  toggleResourceUnit() {
    this.showResourceUnit = !this.showResourceUnit;
  }

  toggleContractType() {
    this.showContractType = !this.showContractType;
  }

  toggleProvider() {
    this.showProvider = !this.showProvider;
  }


  handleNumAnnoMeseFrom() {
    this.numAnnoMeseFrom = this.annoMeseFormGroup.value.annoMeseFrom;
    this.hideTables();
  }
  handleNumAnnoMeseTo() {
    this.numAnnoMeseTo = this.annoMeseFormGroup.value.annoMeseTo;
    this.hideTables();
  }

  hideTables() {
    this.resetRegion();
    this.resetLc();
    this.resetResourceUnit();
    this.resetContractType();
  }

  resetRegion() {
    this.tablesFormGroup.patchValue({
      region: ''
    });

    this.regionSelect = new RegionModel();
    this.serviceChanges.region = this.regionSelect;
  }

  resetLc() {
    this.tablesFormGroup.patchValue({
      localCustomerCod: ''
    });

    this.localCustomerSelect = new LocalCustomerModel();
    this.serviceChanges.localCustomer = this.localCustomerSelect;
  }

  resetResourceUnit() {
    this.tablesFormGroup.patchValue({
      resourceUnit: ''
    });

    this.resourceUnitSelect = new ResourcesUnitModel();
    this.serviceChanges.resourceUnit = this.resourceUnitSelect;
  }

  resetContractType() {
    this.tablesFormGroup.patchValue({
      contractType: ''
    });

    this.contractTypeSelect = new ContractTypeModel();
    this.serviceChanges.contractType = this.contractTypeSelect;
  }

  apriDialog(result: any) {
    const dialogRef = this.dialog.open(DialogSubmitServiceChangesComponent, {
      data: {result}
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });
  }
}
